module.exports = __webpack_public_path__ + "static/media/4.7698e746.gif";